import { render, staticRenderFns } from "./faqContent.vue?vue&type=template&id=2029460a&scoped=true"
import script from "./faqContent.vue?vue&type=script&lang=js"
export * from "./faqContent.vue?vue&type=script&lang=js"
import style0 from "./faqContent.vue?vue&type=style&index=0&id=2029460a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029460a",
  null
  
)

export default component.exports